import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { CommonService } from '@services/common.service';

@Injectable()
export class LoggedInGuard implements CanActivate {

  constructor(private router: Router, private commonService: CommonService) { }

  canActivate() {
    if (this.commonService.getCurrentToken() == null || this.commonService.getCurrentToken() === '') {
      this.router.navigate(['/login']);
      return false;
    } else {
      return true;
    }
  }

}
